import React from 'react'
import BtnHistory from '@assets/web-v3-images/btn-History.png'

export default function ButtonTab({ text, active, onClick }) {
	return (
		<button className="
					relative
					w-auto
					w-full
					max-w-[220px]
					h-[80px]
					shrink-0 p-0 outline-none cursor-pointer btn-click-active" onClick={onClick}>
			<img
				src={BtnHistory}
				className={`absolute inset-0 w-full h-full transition  ${active ? "scale-100" : "opacity-60 hover:opacity-100"
					}`}
			/>
			<span
				className={`
					px-7
					relative
					 z-10 
					text-[28px] flex h-full items-center justify-center font-extrabold text-[rgba(251,245,218,1)] text-xl ${active ? "" : "opacity-40"}`}
				style={{
					WebkitTextStroke: "4px #E04F16",
					paintOrder: "stroke fill",
				}}
			>
				{text}
			</span>
		</button>
	)
}
